import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Candidatura } from '@app/features-modules/bolsa-de-profissionais/api';
import { DrawerModule } from 'primeng/drawer';
import { TagModule } from 'primeng/tag';
import { PerfilProfissionalComponent } from '../perfil-profissional/perfil-profissional.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { MessageService } from 'primeng/api';
import { ApiService } from '@core/providers/http';
import { CandidaturaDetalheComponent } from '../../../candidaturas/candidatura-detalhe/candidatura-detalhe.component';
import { AvatarModule } from 'primeng/avatar';
import { getInitials } from '@shared/pipes/initials.pipe';
import {
  CandidaturaService,
  ProfissionalService,
} from '@app/features-modules/bolsa-de-profissionais/services';
@Component({
  selector: 'app-card-candidatura',
  standalone: true,
  imports: [
    CommonModule,
    TagModule,
    DrawerModule,
    PerfilProfissionalComponent,
    ToastModule,
    ButtonModule,
    CandidaturaDetalheComponent,
    AvatarModule,
  ],
  templateUrl: './card-candidatura.component.html',
  styleUrls: ['./card-candidatura.component.scss'],
  providers: [
    MessageService,
    ApiService,
    CandidaturaService,
    ProfissionalService,
  ],
})
export class CardCandidaturaComponent implements OnInit, OnChanges {
  @Input() profissional!: string;
  @Input() candidato!: any;
  @Input() vaga!: any;
  @Input() designacaoFuncao!: string;
  @Input() telefonePrincipal!: string;
  @Input() activo!: boolean;
  @Input() dataCandidatura!: Date;
  @Input() nivelHabilitacao!: string;
  photoUrl: string | ArrayBuffer | null = null;
  imageError = false;
  router = inject(Router);
  route = inject(ActivatedRoute);
  candidaturaService = inject(CandidaturaService);
  messageService = inject(MessageService);
  profissionalService = inject(ProfissionalService);
  @Output() onCloseModal = new EventEmitter<boolean>();

  maisDetalheProfissional: Candidatura | null = null;
  showDetalhe: boolean = false;
  candidaturaRequest: Candidatura | null = null;

  getInitials(name?: string | null): string {
    return getInitials(name);
  }

  ngOnInit(): void {
    const id = Number(this.route.snapshot.paramMap.get('id'));
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.imageError = false;
    if (changes['candidato'] && this.candidato) {
      const id = this.candidato?.id || this.candidato?.profissional?.id;
      if (id) {
        this.getCandidatura(id);
      }
    }
  }

  getCandidatura(id: any): void {
    this.candidaturaService.show(id).subscribe({
      next: (result) => {
        if (result.retorno?.codigo === 200 && result.data) {
          this.candidaturaRequest = result.data;
          this.getPhotoByProfissionalId(
            this.candidato?.profissional?.id ||
            this.candidaturaRequest?.profissional?.id
          );
        }
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load candidatura details',
        });
      },
    });
  }

  getPhotoByProfissionalId(id: number): void {
    this.profissionalService.getPhoto(id as any)
      .subscribe(
        (response: Blob) => {
          if (response) {
            const reader = new FileReader();
            reader.onload = () => {
              this.photoUrl = reader.result as string; // Define a URL da foto
            };
            reader.readAsDataURL(response); // Lê o Blob como Data URL
          } else {
            this.photoUrl = null;
          }
        },
        (error) => {
          this.photoUrl = null;
        }
      );
  }

  actionClick(candidatura: Candidatura): void {
    this.maisDetalheProfissional = candidatura;
    this.showDetalhe = true;
  }

  getSeverity(estado: string): 'success' | 'danger' | 'warn' | 'info' {
    switch (estado) {
      case 'Pendente': // Aberto
        return 'success';
      case 'Elegível':
        return 'info';
      case 'Não Elegível':
        return 'danger';
      case 'Suspensão Temporária':
        return 'warn';
      case 'Suspensão Definitiva':
        return 'danger';
      case 'Desistente':
        return 'danger';

      default:
        return 'info';
    }
  }

  closeDrawer(): void {
    this.showDetalhe = false;
    this.onCloseModal.emit(true);
  }
}
